module.exports = __webpack_public_path__ + "img/r-logo.05cb9322.svg";